import { FC } from "react";

import {
	FieldLayout,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";
 
interface IQHSFSetupFieldsPanel {}
export const QHSFSetupFieldsPanel: FC<IQHSFSetupFieldsPanel> = ({}) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				label="Min."
				id="minimumQhsf"
				testId={`minimum-Qhsf`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="Max."
				id="maximumQhsf"
				testId={`maximum-Qhsf`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"normalizeQhsf"}
				label="Normalize"
				testId="normalize-Qhsf"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"rate1Qhsf"}
				label="Rate 1"
				testId="rate1-Qhsf"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="Rate 2"
				id="rate2Qhsf"
				testId={`rate2-Qhsf`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
